module.exports='<footer class="footer"><p class="footer__copy">&copy GoPlanr {{ ::landingController.getCurrentYear() }}. All rights reserved</p></footer>';